import React, { useEffect } from 'react';
import { Modal } from 'antd';
import FileSaver from 'file-saver';
import axios from 'axios'
import fileDownload from 'js-file-download'
import html2canvas from 'html2canvas';
//var fs = require('fs'),
//request = require('request');
import { saveAs } from 'file-saver'


export default function ViewNinDocModal({
  showModal,
  hideModal,
  title,
  className,
  data,
  handleApprove,
  handleReject
}) {

  const downloadImage = () => {
    handleImageDownload()
    saveAs(data.url, data.title) // Put your image url here.
  }


  const handleImageDownload = async () => {
    const element = document.getElementById('print'),
    canvas = await html2canvas(element,{useCORS:true,allowTaint: true, width:window.screen.availWidth, height: window.screen.availHeight, x: 0, y: window.pageYOffset}),
    data = canvas.toDataURL('image/jpg'),
    link = document.createElement('a');
 
    link.href = data;
    link.download = 'downloaded-image.jpg';
 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);  };

    useEffect(()=>{
    },[]);

  return (
    <Modal
      className={className}
      title="Approve NIN"
      centered
      open={showModal}
      onOk={() => hideModal(false)}
      onCancel={() => hideModal(false)}
      width={800}
      footer={0}
    >
      <h4 className='text-center'>{data.title}</h4>
      <div id="print" className='text-center mt-5'>
        {data.ninImage && data.userImage ? (
            <div className='flex justify-content-center'>
              <div style={{ flexDirection: 'column', alignItems: 'center' }}>
                
              <div>
              <img src={data.ninImage} alt='nin' style={{ width: '50%' }} />
              </div>
              <div>
                  Name on NIN:
                </div>
              <div>
                <label style={{ fontWeight: 'bold'}}>First Name:</label> {data.ninFirstName} 
                <label style={{ fontWeight: 'bold'}}>Middle Name: </label>{data.ninMiddleName ?? 'N/A '} 
                <label style={{ fontWeight: 'bold'}}>Last Name: </label>{data.ninLastName?? 'N/A'}
                <br />
              </div>
            </div>
            <div style={{ flexDirection: 'column', alignItems: 'center' }}>
            <div className='m-3'>
            <img src={data.userImage} alt='userImage' style={{ width: '50%' }} />
            </div>
            <div>
              Name on Account:
            </div>
            <div>
            <label style={{ fontWeight: 'bold'}}>First Name:</label>{data.userFirstName} 
            <label style={{ fontWeight: 'bold'}}>Last Name:</label>{data.userLastName}
              <br />
            </div>
            </div>

            <div className='text-center mt-5'>
            <button className='btn btn-outline-success' onClick={handleApprove}>Approve</button>
            <button className='btn btn-outline-danger' onClick={handleReject}>Reject</button>
            </div>
            </div>

        ) : (
          <span>No image found {data?.url}</span>
        )}
      </div>

     

      <div className={data.url ? 'text-center mt-5' : 'd-none'}>
      
      {//<button className='btn btn-outline-success' onClick={downloadImage}>Download!</button>
      }
     
      
      </div>
    </Modal>
  );
}
